import { basicEnum } from "./base";

export const DocumentTypeEnum = basicEnum([
    {
        label: "CUSTOMER INSTALLATION",
        value: "CI",
    },
    {
        label: "RESELLER INSTALLATION",
        value: "RI",
    },
    {
        label: "CUSTOMER MODIFICATION",
        value: "CM",
    },
    {
        label: "RESELLER MODIFICATION",
        value: "RM",
    },
    {
        label: "CUSTOMER DISMANTLE",
        value: "CD",
    },
    {
        label: "RESELLER DISMANTLE",
        value: "RD",
    },
]);

export namespace DocumentTypeEnum {
    export type Labels = (typeof DocumentTypeEnum)["labels"][number];
    export type Values = (typeof DocumentTypeEnum)["values"][number];
}
